import * as yup from 'yup';

export const customFieldsValidationsSchema = (t: any) => yup.object({
  fieldName: yup.string().required(t('fieldNameIsRequired')),
  fieldType: yup.number().required(t('fieldTypeIsRequired')),
  isRequired: yup.boolean(),
});
